(function () {
  /**
   * Decide which upsell tile to show given current cart contents.
   * Mirrors the audit-stage spec exactly.
   *
   * @param {string[]} cartHandles - distinct product handles in cart
   * @returns {{partner: string, mode: 'mix-match' | 'cross-sell', anchor: string|null}|null}
   */
  function pickUpsell(cartHandles) {
    var has = function (h) { return cartHandles.indexOf(h) !== -1; };

    // 1. Already has a valid pair? Don't push another pair.
    if (has('glazy-cloud') && has('glazy-pop')) return null;
    if (has('glazy-pop') && has('thirsty-glazy')) return null;

    // 2. Mix-and-match upsells.
    if (has('glazy-cloud'))   return { partner: 'glazy-pop',    mode: 'mix-match', anchor: 'glazy-cloud' };
    if (has('glazy-pop')) {
      if (!has('glazy-cloud'))   return { partner: 'glazy-cloud',   mode: 'mix-match', anchor: 'glazy-pop' };
      if (!has('thirsty-glazy')) return { partner: 'thirsty-glazy', mode: 'mix-match', anchor: 'glazy-pop' };
      return null;
    }
    if (has('thirsty-glazy')) return { partner: 'glazy-pop', mode: 'mix-match', anchor: 'thirsty-glazy' };

    // 3. Cart contains ONLY Glazy Straight → cross-sell, no pair discount.
    if (cartHandles.length === 1 && cartHandles[0] === 'glazy-straight-hair-oil') {
      return { partner: 'glazy-cloud', mode: 'cross-sell', anchor: 'glazy-straight-hair-oil' };
    }

    // 4. Empty cart or non-hero contents → nothing.
    return null;
  }

  class GlazyCartUpsell extends HTMLElement {
    connectedCallback() {
      this.mount = this.querySelector('[data-role=mount]');
      this.discountPct = parseInt(this.dataset.mixMatchDiscountPct, 10) || 10;

      var self = this;
      document.addEventListener('cart:refresh', function () { self.render(); });
      document.addEventListener('cart-drawer:open', function () { self.render(); });
      // Theme-native event fired by assets/theme-global.js after any ATC.
      document.addEventListener('product-ajax:added', function () { self.render(); });

      this.render();
    }

    async render() {
      if (!this.mount) return;
      try {
        var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        var handles = Array.from(new Set((cart.items || []).map(function (i) { return i.handle; })));
        var decision = pickUpsell(handles);
        this.mount.innerHTML = '';
        if (!decision) return;
        var tile = this.buildTile(decision);
        if (tile) this.mount.appendChild(tile);
      } catch (err) {
        console.warn('[glazy-cup] render failed', err);
      }
    }

    buildTile(decision) {
      var tpl = this.querySelector('template[data-upsell-handle="' + decision.partner + '"]');
      if (!tpl) return null;
      var node = tpl.content.firstElementChild.cloneNode(true);
      var variantId = tpl.dataset.variantId;

      var copyEl = node.querySelector('[data-role=copy]');
      var badgeEl = node.querySelector('[data-role=badge]');
      var addBtn = node.querySelector('[data-role=add]');

      if (decision.mode === 'mix-match') {
        var copyKey = decision.anchor + '|' + decision.partner;
        if (copyEl) copyEl.textContent = (window.GLAZY_PAIR_COPY && window.GLAZY_PAIR_COPY[copyKey]) || ('Pair with ' + decision.partner);
        if (badgeEl) {
          badgeEl.textContent = this.discountPct + '% MIX & MATCH';
          badgeEl.classList.add('glazy-cup__badge--mm');
        }
      } else {
        if (copyEl) copyEl.textContent = 'Complete your routine';
        if (badgeEl) badgeEl.textContent = '';
      }

      var self = this;
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          self.addAndRefresh(addBtn, variantId, decision.mode);
        });
      }

      return node;
    }

    async addAndRefresh(btn, variantId, mode) {
      btn.disabled = true;
      try {
        var item = { id: variantId, quantity: 1 };
        if (mode === 'mix-match') item.properties = { _glazy_mm_pair: 'true' };
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!res.ok) {
          var err;
          try { err = await res.json(); } catch (_) { err = { description: 'Add to cart failed' }; }
          throw new Error(err.description || 'Add to cart failed');
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        console.error('[glazy-cup] add failed', err);
        alert('Sorry — couldn’t add to cart. Please try again.');
      } finally {
        btn.disabled = false;
      }
    }
  }

  if (!customElements.get('glazy-cart-upsell')) {
    customElements.define('glazy-cart-upsell', GlazyCartUpsell);
  }
})();
